import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'flash_sales-warehouse_sale_homepage_carousel-view';

/**
 * Use to track the view of the warehouse sale homepage carousel.
 */
export function trackFlashSalesWarehouseSaleHomepageCarouselView(
  retailerToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { retailerToken },
  });
}
